import Tooltip from '@kvika/tooltip'
import { Colors, Spacing } from '@kvika/audur-theme'
import styled from 'styled-components'

export const StyledTooltip = styled(Tooltip).attrs<{ borderColor?: string }>((props) => ({
	borderColor: props.borderColor || Colors.LightOrange.toString(),
}))`
	background-color: ${(props) => props.borderColor} !important;
	z-index: 1000;
	padding: ${Spacing.Small};
	& > div {
		display: none;
	}
`

export const StyledButton = styled.button`
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const StyledCloseButton = styled.button`
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 5px;
	align-self: flex-start;
	display: flex;
`

export const Backdrop = styled.div`
	position: fixed;
	inset: 0;
	z-index: 998;
`

// Rendered as <main> (not a div) on purpose: StyledTooltip's `& > div { display: none }`
// hides the tooltip's arrow, which is a direct-child div of the content container. A div
// content root would get hidden too — a non-div wrapper dodges the selector (mirrors the
// sibling audur-online-bank's FontWrapper).
export const StyledFontWrapper = styled.main`
	font-family: var(--CircularXX), Arial, sans-serif;
`

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
`

export const StyledTitleRow = styled.div`
	display: flex;
`

export const StyledHeading = styled.h4`
	flex: 1;
	margin-top: ${Spacing.Small};
	margin-bottom: ${Spacing.Medium};
	color: ${Colors.DarkGray};
`
